//import { HttpError } from './http-error'
import axios from "axios"
import querystring from 'querystring'

export class Http {
    constructor() {
    }

    async postForm(url = '', data = {}, options = {}) {
        let authHeader = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const opt = {
            ...options, headers: { ...options.headers, ...authHeader }
        };
        try {
            return await axios.post(url, querystring.stringify(data), opt);
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
    async request(options = {}) {
        try {
            let res= await axios(options);
            return res;
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
    async get(url = '', options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.get(url, opt);
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
    async post(url = '', data = {}, options = {}) {
        const opt = {
            ...options
        };
        try {
            let res = await axios.post(url, data, opt);
            return res;
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
    async put(url = '', data = {}, options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.put(url, data, opt);
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
    async delete(url = '', options = {}) {
        const opt = {
            ...options
        };
        try {
            return await axios.delete(url, opt);
        }
        catch (e) {
            let res = { data: e.response.data };
            throw res;
        }
    }
}
